module.exports = __webpack_public_path__ + "static/media/login.bed511a8.svg";